import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Button } from 'components/common/Elements/Elements';

import classes from './BodyDropdownSetting.module.scss';

const BodyDropdownSetting = ({ items }) => {
  return (
    <ul className={classes.listWrap}>
      {items.map(
        item =>
          !item.hide && (
            <li key={item.label} className={classes.option}>
              <Button
                onClick={item.handleClick}
                className={cn(
                  classes.button,
                  item.isWarning && classes.button_warning,
                  item.isDisabled && classes.button_disabled
                )}
              >
                {item.label}
              </Button>
            </li>
          )
      )}
    </ul>
  );
};

BodyDropdownSetting.propTypes = {
  items: PropTypes.array.isRequired
};

export default BodyDropdownSetting;
